/* 孫堅傳・第 1 章：西華之敗（中平元年，184）
 * 史實：《三國志·孫堅傳》「儁表請堅爲佐軍司馬，鄕里少年隨在下邳者皆願從。」
 *       裴注引《吳書》「堅乘勝深入，於西華失利。堅被創墮馬，臥草中。軍衆分散，不知堅所在。
 *       堅所騎驄馬馳還營，踣地呼鳴，將士隨馬於草中得堅。堅還營十數日，創少愈，乃復出戰。」
 * 流程：集結鄉里少年 → 渡河攻破兩處黃巾營地（解鎖 W、E）→ 追到西華中伏、墮馬重傷 → 躲在草叢裡，驄馬回營 →
 *       程普循蹄印來救 → 殺出重圍 → 還營十數日 → 擊退彭脫（敵將撤走即勝利）。
 * 對白是遊戲的演繹；旁白卡只引原文。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';

const A = [1000, 4300]; // 漢軍營
const FALL = [7700, 5900]; // 西華：東南小路的盡頭，草野的北緣
const HIDE = [7800, 6260]; // 墮馬後滾進的草叢
const CAMP_A = [7300, 3200], BIG = [9800, 2900];
const GATE = [8250, 2080], CHIEF = [8480, 1560]; // 渠帥營（黃巾前哨）：前門守兵在南，渠帥在營後，東北邊有草叢
const RECRUITS = [[3450, 1750], [3950, 1750], [3500, 1300], [4150, 1550], [4250, 6250], [4700, 6200], [4400, 6700], [4850, 6550]]; // 北村四人、南村四人
const JOIN = ['願隨孫司馬！', '打黃巾，算我一個！', '娘，我跟孫司馬去了！', '等這一天很久了！'];
// 村民：走來走去、在田裡幹活；走近了會跟孫堅說幾句（有的是傳聞，有的是哪裡掉了東西的提示）
const FOLK = [
  [3600, 1500, '老農', '黃巾一來，糧都被搶光了……孫司馬要替我們做主啊。'], [3250, 1250, '農夫', '今年春汛來得早，田裡的水都漫過埂了。', 'hoe'],
  [3850, 1350, '樵夫', '西北那片岩丘後頭，前些天看見有人丟了一捆竹簡。'], [4250, 1650, '農婦', '我家那小子也嚷著要跟孫司馬去打黃巾。', 'hoe'],
  [3700, 1700, '貨郎', '汝水上的橋還在修，要過河得等工匠把橋板鋪好。'],
  [4500, 6400, '漁夫', '渡口的水急得很，千萬別涉水，去年就淹死過人。'], [4300, 6550, '老嫗', '西南那片岩石後頭，好像有官軍丟下的皮甲。'],
  [3700, 6350, '農夫', '東南的西華草深得很，人一躺進去，誰也找不著。', 'hoe'], [4650, 6500, '村童', '孫司馬好威風！我長大也要跟你去打仗！'],
  [8900, 5300, '村人', '黃巾就在東北紮大營，夜裡都不敢出門。'], [9100, 5450, '老丈', '彭脫那廝使一柄開山大斧，凶得很，孫司馬千萬小心。'], [8750, 5450, '村婦', '村子北邊的岩石那頭，像是有人藏了什麼東西。'],
];
// 西華草野的搜索點：四片草叢（(7900,6300)、(8700,6000)、(7400,6800)、(8400,6900)）的外緣一圈，加上探進草裡的點
const FIELD = [[7900, 6300], [8700, 6000], [7400, 6800], [8400, 6900]];
function searchPts() {
  const M = SG.MAP, out = [];
  M.brush.forEach((b, i) => {
    if (!FIELD.some(([x, y]) => x === b[0] && y === b[1])) return;
    for (let k = 0; k < 10; k++) { const a = (k / 10) * Math.PI * 2, c = Math.cos(a), s = Math.sin(a); out.push([b[0] + c * (b[2] + 70), b[1] + s * (b[3] + 50)]); }
    for (const [fx, fy] of [[-0.45, 0], [0.45, 0], [0, 0.3]]) out.push([b[0] + fx * b[2], b[1] + fy * b[3], i]);
  });
  return out.filter((p) => M.walkable(p[0], p[1], M.BODY));
}
const HIDE_T = 60;
// 散落在地圖上的東西：多半在路外、岩後、草裡、村子角落，要自己探索才撿得到
const LOOT = [
  [1500, 1250, 'book', { n: 300 }], [4150, 1250, 'item', { id: 'jinchuang' }], [2200, 3000, 'item', { id: 'jinchuang' }], // 西岸：岩後、北村、草叢
  [2600, 5600, 'gold', { n: 80 }], [2900, 6700, 'item', { id: 'leather' }], [4800, 6700, 'gold', { n: 120 }], [4900, 3150, 'item', { id: 'xingshen' }],
  [6300, 3500, 'gold', { n: 100 }], [6500, 2800, 'book', { n: 400 }], [7600, 2000, 'item', { id: 'yanwu' }], // 東岸：河邊、沼澤、前哨旁的草
  [9000, 4750, 'item', { id: 'iron_sword' }], [9200, 5500, 'food', { n: 0.5 }], [6000, 6800, 'item', { id: 'jade' }], [9900, 1500, 'gold', { n: 200 }], // 西華村、東南沼澤、東北角
];

// 汝南黃巾的首領。正史只記皇甫嵩「擊彭脫於西華」（《後漢書·皇甫嵩傳》），他的武藝是演繹
export const PENGTUO = H('pengtuo', '彭脫', '汝南黃巾', 'neutral', '戰士', 'axe', {
  weaponName: '開山斧', head: 'headband', eye: 'fierce', beard: 'bushy', bulk: 1.25, size: 1.18, skin: '#c8905e', fx: '#f2c230',
  c: { armor: '#b8902a', sleeve: '#5a4626', cloth: '#6a5530', trim: '#d9a82a', pants: '#4a3f30', boot: '#3a2e22', cape: '#e0b02a', belt: '#6a4a26', metal: '#7e8379', band: '#f2c230', plume: '#f2c230', pole: '#4a3b30' },
}, [
  ['黃天斧', 'crescent', '揮出斧風，造成 {150/150/150/150} 傷害。'],
  ['蠻衝', 'charge', '衝撞造成 {120/120/120/120} 傷害。'],
  ['旋斧', 'spin', '旋斧橫掃周圍，每圈 {70/70/70/70} 傷害。'],
  ['劈山', 'slam', '躍起重劈，造成 {200/200/200} 傷害。'],
]);

// 程普：跟著帶頭的人走，看到敵人就打，偶爾放技能
function npc(w, u, lead) {
  const I = u.input;
  if (!u.alive) return;
  let foe = null, bd = u.route ? 200 : 520; // 循蹄印找人的路上：不去招惹遠處的搜索兵
  for (const t of w.units) if (w.isEnemy(u, t) && t.team === 1) { const d = SG.gd(u.x, u.y, t.x, t.y); if (d < bd) { bd = d; foe = t; } }
  if (foe) {
    I.target = foe; I.engage = true;
    if (!u.act && SG.rand() < 0.04) { const i = [0, 1, 2].find((k) => u.cd[k] <= 0 && u.skillLv[k] > 0); if (i !== undefined) I.skill = { i, x: foe.x, y: foe.y }; }
    return;
  }
  I.target = null; I.engage = false;
  if (u.route) return; // 循蹄印走的路上：照路徑點走
  if (lead && lead.alive && SG.gd(u.x, u.y, lead.x, lead.y) > 260) I.moveTo = [lead.x - 110 * lead.f, lead.y + 50];
}

function setLevel(w, u, lv) {
  const need = SG.expToLevel(lv) - u.exp;
  if (need > 0) w.addExp(u, need / w.tune.exp + 1, true);
}

export default {
  id: 'sunjian-1', map: 'xihua', hero: 'sunjian',
  gold: 0, // 第 1 章：金錢只靠殺敵
  next: 'sunwu-2', // 第二幕：宛城先登（評星在第二幕）
  title: '第 1 章　西華・宛城（上）', year: '中平元年（184）',
  brief: {
    quote: [
      { text: '儁表請堅爲佐軍司馬，鄕里少年隨在下邳者皆願從。堅又募諸商旅及淮泗精兵，合千許人，與儁並力奮擊，所向無前。', src: '《三國志·吳書·孫堅傳》' },
    ],
    text: '黃巾起事，朱儁奉命討伐汝南、潁川的黃巾，上表請孫堅擔任佐軍司馬。孫堅帶著下邳的鄉里少年投入朱儁軍中。',
    goals: ['集結鄉里少年', '渡河追擊，攻破黃巾營地', '擊退彭脫', '（下半）宛城先登'],
  },
  // 評星在第二幕（sunwu-2）：西華看「重傷躲藏時沒有被發現」（m.vars.spotted）
  steps: [
    { // 1. 集結鄉里少年（新手教學：只有 Q）
      enter(m, w) {
        m.lock([1, 2, 3]);
        m.vars.recruits = RECRUITS.map(([x, y], i) => { const u = m.recruit(x, y); m.mark('r' + i, u.x, u.y, '少年', true); return u; });
        m.obj('gather', '集結鄉里少年', RECRUITS.length);
        for (const [x, y, k, o] of LOOT) m.loot(x, y, k, o);
        for (const [x, y, name, say, work] of FOLK) m.folk(x, y, { name, say, work });
        // 卡點：人還沒到齊，汝水過不去——橋正在修，上下游的渡口水急
        const B = SG.MAP.bridges[0], e0 = B.pts[0], e1 = B.pts[B.pts.length - 1];
        m.gate('bridge', B.x, B.y, 130, 'repair', ['工匠', '橋板還沒鋪好，過不去哪！孫司馬先把鄉里子弟集齊，橋也就修好了。'], { a: Math.atan2(e1[1] - e0[1], e1[0] - e0[0]), w: 190 });
        for (const [i, f] of SG.MAP.rivers[0].fords.entries()) m.gate('ford' + i, f[0], f[1], 290, 'flood', ['孫堅', '春汛水急，渡口涉不過去。等橋修好，走大路過河吧。']);
        m.after(20, () => { if (m.i === 0) m.line('提示', '北村、南村有商舖（地圖上的「商」），殺敵得來的金錢可以在那裡或漢軍營買裝備。'); });
        m.after(32, () => { if (m.i === 0) m.line('提示', '地上閃著光的錢囊、糧袋、兵書與裝備，走過去就能拾獲。路外、草裡、村子角落多找找。'); });
        m.line('孫堅', '鄉里子弟，願隨我討賊的，跟我走！');
        m.after(4, () => m.line('提示', '鄉里少年在北村、南村，走到他身邊他就會跟著你。先按 Alt＋Q（或點 Q 上的 ＋）學會第一招。'));
        // 新手教學：Shift＋右鍵排行軍路線（少年散在營地四周，正好一口氣排好路線去找）
        if (!w.campaign.touch) m.after(9, () => {
          if (m.i !== 0) return;
          m.obj('route', '用 Shift＋右鍵排一條行軍路線（3 個點）');
          m.line('提示', '按住 Shift 再按右鍵，可以一次排好好幾個路點，孫堅會照順序一路走過去。試著排一條路線去找少年。');
        });
      },
      tick(m, w) {
        const me = w.player;
        let n = 0;
        m.vars.recruits.forEach((u, i) => {
          if (u.owner) { n++; return; }
          if (u.alive && SG.gd(u.x, u.y, me.x, me.y) < 140) { m.join(u, me); m.unmark('r' + i); n++; m.line('鄉里少年', JOIN[n % JOIN.length]); }
        });
        m.prog('gather', n);
        const r = m.get('route'), I = me.input;
        if (r && !r.done && I.wp && I.wp.length >= 2) { // 目前的目的地＋排隊中的兩個點
          m.done('route');
          m.line('提示', '路線排好了，虛線就是行軍路線。不按 Shift 直接右鍵，就會取消路線、改走新的地方。');
        }
        if (n < RECRUITS.length) return false;
        if (r && !r.done) m.drop('route'); // 沒學也不卡關
        m.ungate('bridge'); m.ungate('ford0'); m.ungate('ford1');
        m.line('工匠', '橋修好啦！孫司馬，請過河！');
        return true;
      },
    },
    { // 2. 渡河追擊：第一處營地正面打，破了學會 W（赤幘：隱身）
      enter(m, w) {
        m.line('孫堅', '人齊了。渡河，追擊汝南的黃巾！');
        m.vars.ca = m.camp(CAMP_A[0], CAMP_A[1], [['huangjin', 5]]);
        [[6300, 4120], [6500, 4060], [6400, 4200]].forEach(([x, y]) => m.patrol(m.foe('huangjin', x, y), [[6150, 4180], [7050, 3880]]));
        m.mark('ca', CAMP_A[0], CAMP_A[1], '黃巾營');
        m.obj('camps', '渡河追擊，攻破黃巾營地', 2);
      },
      tick(m) {
        if (m.alive(m.vars.ca).length) return false;
        m.unmark('ca'); m.prog('camps', 1);
        m.unlock(1, '攻破營地！學會了 W「赤幘」');
        return true;
      },
    },
    { // 2b. 渠帥營：前門守兵多，正面硬打折損大；渠帥在營後，旁邊有草叢。先殺渠帥，賊眾自散
      enter(m, w) {
        const guards = [];
        for (let i = 0; i < 9; i++) guards.push(m.foe('huangjin', GATE[0] - 200 + (i % 5) * 100, GATE[1] + Math.floor(i / 5) * 70 + (i % 2) * 20));
        const chief = m.foe('bandit', CHIEF[0], CHIEF[1], { hp: 900, maxHp: 900 });
        m.vars.cb = guards.concat(chief); m.vars.guards = guards; m.vars.chief = chief;
        m.mark('cb', CHIEF[0], CHIEF[1], '渠帥', false, chief);
        m.after(1.5, () => m.line('孫堅', '前門賊兵眾多，硬拚必有折損。擒賊先擒王——渠帥在營後，渠帥一死，賊眾自散。'));
        m.after(7, () => m.line('提示', '學會 W「赤幘」就能隱身。讓少年在營外等著，從北邊的草叢摸到渠帥身後，先殺渠帥。'));
      },
      tick(m, w) {
        const { guards, chief } = m.vars;
        // 前門守兵互相支援：一個被驚動，整個前門都來
        const t = guards.map((u) => u.alive && u.target && u.target.alive && u.target).find(Boolean);
        if (t) for (const u of guards) if (u.alive && !u.rout && !u.target && SG.gd(u.x, u.y, t.x, t.y) < 900 && w.isEnemy(u, t)) { u.target = t; u.think = 0.35; }
        if (chief.alive && m.alive(guards).length) return false;
        if (!chief.alive && m.alive(guards).length) {
          // 賊眾潰散：往北逃走，幾秒後消失
          m.vars.routed = true;
          m.big('渠帥已死，賊眾潰散！');
          m.line('黃巾', '渠帥死了！快逃啊！');
          for (const u of m.alive(guards)) { u.rout = true; u.untargetable = true; u.target = null; u.aggro = null; u.patrol = null; u.home = [u.x + 500, 600]; u.ms = 300; }
          m.after(4, () => { for (const u of guards) if (u.alive) { u.alive = false; u.counted = true; u.deadT = w.t; } });
        }
        m.unmark('cb'); m.prog('camps', 2);
        m.unlock(2, '攻破渠帥營！學會了 E');
        return true;
      },
    },
    { // 3. 乘勝深入
      enter(m) {
        m.line('孫堅', '賊眾往東南逃了，乘勝追擊，別讓他們喘息！');
        m.obj('chase', '乘勝追擊，往西華去');
        m.mark('fall', FALL[0], FALL[1], '西華');
      },
      tick(m, w) { return m.near(w.player, FALL[0], FALL[1], 280); },
    },
    { // 4. 中伏、墮馬、躲藏
      enter(m, w) {
        const me = w.player;
        m.done('chase'); m.unmark('fall');
        m.big('中伏！');
        m.vars.ambush = [];
        for (let i = 0; i < 9; i++) { const a = Math.PI * (1.05 + (i / 8) * 0.9); m.vars.ambush.push(m.foe('huangjin', me.x + Math.cos(a) * 650, me.y + Math.sin(a) * 450)); } // 北半圈：草野在南邊
        m.line('黃巾', '蒼天已死，黃天當立！');
        m.after(2.2, () => {
          // 墮馬：滾進草叢、重傷；鄉勇被衝散
          me.x = HIDE[0]; me.y = HIDE[1]; me.hp = Math.max(1, Math.min(me.hp, me.maxHp * 0.3)); me.st.stun = 1.2;
          me.input = {}; m.vars.wounded = true; m.vars.hideHp = me.hp;
          w.fx({ k: 'puff', x: me.x, y: me.y });
          m.vars.scattered = 0;
          for (const u of m.vars.recruits) if (u.alive) { u.alive = false; u.counted = true; u.deadT = w.t; m.vars.scattered++; w.fx({ k: 'puff', x: u.x, y: u.y }); }
          m.card('堅被創墮馬，臥草中。軍衆分散，不知堅所在。', '《吳書》');
          const pts = searchPts();
          m.vars.ambush.forEach((u) => { u.target = null; u.aggro = null; u.think = 0.6; m.search(u, pts, me); }); // 追丟了：改成在草野裡搜索
          const BARK = ['人呢？那姓孫的跑不遠！', '往草裡找找！', '這邊沒有……再往東看看。', '他中了刀，一定躲在附近！', '仔細搜，別漏了哪片草！'];
          const bark = (k) => { if (!m.vars.wounded || m.vars.cp) return; m.line('黃巾', BARK[k % BARK.length]); m.after(9 + SG.rand() * 5, () => bark(k + 1)); };
          m.after(5, () => bark(0));
          // 驄馬：自己跑回漢軍營，沿路留下蹄印
          const path = SG.MAP.path(FALL[0], FALL[1], A[0] + 200, A[1]);
          m.vars.horse = { x: FALL[0], y: FALL[1], f: -1, path, i: 0, last: [FALL[0], FALL[1]], trail: [[FALL[0], FALL[1]]] };
          m.obj('hide', '重傷：躲在草叢裡，等援兵循蹄印來救');
          m.vars.hideT = 0;
        });
      },
      tick(m, w, dt) {
        if (!m.vars.wounded) return false;
        m.vars.hideT += dt;
        const left = Math.max(0, Math.ceil(HIDE_T - m.vars.hideT)), o = m.get('hide');
        if (o) o.text = left > 0 ? `重傷：躲在草叢裡，等援兵循蹄印來救（${left} 秒）` : '援兵就快到了，撐住！';
        // 援兵：躲了 40 秒後，程普帶著散兵從蹄印半途出發
        if (!m.vars.cp && m.vars.hideT > 40) {
          const tr = m.vars.horse.trail, k = Math.min(tr.length - 1, Math.round(2400 / 60)), s = tr[k]; // 從墮馬處沿蹄印往回 2400
          const cp = w.addHero(SG.HEROES.find((h) => h.id === 'chengpu'), 0, false);
          cp.human = true; cp.npc = true; cp.x = s[0]; cp.y = s[1]; setLevel(w, cp, w.player.lv);
          cp.route = true;
          cp.input.wp = tr.slice(0, k).reverse().filter((_, j) => j % 4 === 0).concat([[HIDE[0], HIDE[1]]]);
          cp.input.moveTo = cp.input.wp.shift();
          m.vars.cp = cp;
          m.vars.back = [];
          for (let i = 0; i < m.vars.scattered; i++) { const u = m.recruit(s[0] - 80 - i * 30, s[1] + ((i % 3) - 1) * 50); m.join(u, cp); m.vars.back.push(u); }
          m.line('程普', '驄馬自己跑回營，還踣地悲鳴……司馬一定在西華的草野裡！跟著蹄印走！');
        }
        const cp = m.vars.cp;
        if (cp && cp.route && !cp.input.moveTo) cp.input.moveTo = [w.player.x, w.player.y]; // 走完蹄印就直接找人
        if (m.vars.hideT > 95 && cp && cp.alive && SG.gd(cp.x, cp.y, w.player.x, w.player.y) > 900) { const p = SG.MAP.nearestFree(w.player.x - 300, w.player.y); cp.x = p[0]; cp.y = p[1]; } // 保險：卡住了就直接到
        return cp && cp.alive && SG.gd(cp.x, cp.y, w.player.x, w.player.y) < 220;
      },
    },
    { // 5. 得救，殺出重圍
      enter(m, w) {
        const me = w.player, cp = m.vars.cp;
        m.vars.wounded = false; m.done('hide'); m.drop('hide');
        cp.route = false; cp.input.wp = null; cp.input.moveTo = null;
        me.hp = Math.max(me.hp, me.maxHp * 0.6);
        for (const u of m.vars.back) m.join(u, me);
        m.vars.recruits = m.vars.recruits.concat(m.vars.back);
        m.card('將士隨馬於草中得堅。', '《吳書》');
        m.after(1.5, () => m.line('程普', '找到了！司馬撐住，我們殺出去！'));
        m.obj('out', '殺出重圍');
      },
      tick(m, w) {
        const near = m.alive(m.vars.ambush).filter((u) => SG.gd(u.x, u.y, w.player.x, w.player.y) < 1400);
        return !near.length || m.t > 45;
      },
    },
    { // 6. 還營十數日
      enter(m, w) {
        m.done('out');
        m.card('堅還營十數日，創少愈，乃復出戰。', '《吳書》');
        m.after(1.4, () => {
          const me = w.player, cp = m.vars.cp;
          for (const u of m.vars.ambush) if (u.alive) { u.alive = false; u.counted = true; u.deadT = w.t; }
          me.x = A[0] + 200; me.y = A[1]; me.hp = me.maxHp; me.mp = me.maxMp; me.input = {};
          if (cp.alive) { cp.x = A[0] + 120; cp.y = A[1] + 120; cp.hp = cp.maxHp; cp.mp = cp.maxMp; cp.input = {}; }
          m.alive(m.vars.recruits).forEach((u, i) => { u.x = A[0] + 60 - (i % 4) * 50; u.y = A[1] - 100 + Math.floor(i / 4) * 60; u.hp = u.maxHp; });
          // 養傷十數日也沒閒著：打彭脫之前至少 6 級，學得到大招
          if (me.lv < 6) setLevel(w, me, 6);
          if (cp.alive && cp.lv < me.lv) setLevel(w, cp, me.lv);
        });
      },
      tick(m) { return m.t > 2.2; },
    },
    { // 7. 擊退彭脫
      enter(m, w) {
        m.unlock(3, '傷癒復出！學得到 R 了');
        m.line('孫堅', '傷好了。彭脫的大營就在東邊，這回一舉擊破！');
        m.after(3, () => { if (w.canLearn(w.player, 3) === '') m.line('提示', '按 Alt＋R（或點 R 上的 ＋）學會大招，留著打彭脫。'); });
        m.camp(8800, 3150, [['huangjin', 4]], 120);
        m.vars.guards = m.camp(BIG[0], BIG[1], [['huangjin', 6], ['bandit', 2]], 300);
        const [px, py] = SG.MAP.nearestFree(BIG[0], BIG[1]);
        const boss = SG.unit({ kind: 'creep', caster: true, spec: PENGTUO, team: 1, x: px, y: py, home: [px, py], f: -1, r: 28, hp: 3600, maxHp: 3600, atk: 58, armor: 6, asp: 100, ms: 250, range: 85,
          gold: 300, xp: 500, name: '彭脫', think: 0, skillLv: [1, 1, 1, 1], cd: [2, 4, 6, 10] });
        w.units.push(boss);
        m.vars.boss = boss;
        m.mark('boss', BIG[0], BIG[1], '彭脫', false, boss);
        m.obj('boss', '擊退彭脫');
      },
      tick(m, w) {
        const b = m.vars.boss;
        if (!m.vars.fled && (b.hp < b.maxHp * 0.25 || !b.alive)) {
          m.vars.fled = true; m.unmark('boss');
          if (b.alive) { b.untargetable = true; b.home = [10700, 2500]; b.target = null; b.aggro = null; m.line('彭脫', '孫堅這廝好生了得……撤！'); }
          m.big('擊退彭脫！');
          m.done('boss');
          m.after(3, () => { if (b.alive) { b.alive = false; b.counted = true; b.deadT = w.t; } m.win(); });
        }
        return false;
      },
    },
  ],
  always(m, w, dt) {
    const me = w.player;
    if (!me.alive) { m.lose('孫堅陣亡'); return; }
    // 重傷：走不快、不能攻擊、不能放技能；在草叢裡敵人看不到（除非走到身邊）
    if (m.vars.wounded) {
      me.st.disarm = Math.max(me.st.disarm, 0.3); me.st.silence = Math.max(me.st.silence, 0.3);
      me.st.slow = Math.max(me.st.slow, 0.3); me.st.slowAmt = Math.max(me.st.slowAmt, 0.45);
      me.hp = Math.min(me.hp, m.vars.hideHp); // 重傷不會自己回血
      if (me.hp < m.vars.hideHp - 1 && m.vars.hideT > 0.5) m.vars.spotted = true;
      m.vars.hideHp = Math.min(m.vars.hideHp, me.hp);
    }
    const cp = m.vars.cp;
    if (cp) npc(w, cp, m.vars.wounded ? null : me);
    // 驄馬：沿路徑跑回營，每 60 留一個蹄印
    const h = m.vars.horse;
    if (h && h.i < h.path.length) {
      const q = h.path[h.i], dx = q[0] - h.x, dy = q[1] - h.y, d = Math.hypot(dx, dy), v = 520 * dt;
      if (d < v) { h.x = q[0]; h.y = q[1]; h.i++; } else { h.x += (dx / d) * v; h.y += (dy / d) * v; h.f = dx < 0 ? -1 : 1; }
      if (Math.hypot(h.x - h.last[0], h.y - h.last[1]) > 60) { m.prints.push({ x: h.x, y: h.y, a: Math.atan2(h.y - h.last[1], h.x - h.last[0]), t: w.t }); h.last = [h.x, h.y]; h.trail.push([h.x, h.y]); }
      if (h.i >= h.path.length) m.line('旁白', '驄馬馳還營，踣地呼鳴。');
    }
  },
};
